import { Controller } from "@hotwired/stimulus"
import CryptoJS from "crypto-js"

// Connects to data-controller="image-url-generator"
export default class extends Controller {
  static targets = ["url"]
  static values = {
    accession: String
  }

  connect() {
    this.generate();
  }

  generate() {
    if (!this.hasUrlTarget) return
    
    const accessionNumber = this.accessionValue
    const studyInstanceUID = ""
    const seriesInstanceUID = ""
    const entryPoint = "/study/auth/1?"
    const host = "http://186.182.243.155:8090"
    const secretKey = "b807424e1b3385aa8162ab5849aff013d430339f"

    try {
      const url = this.getUrl(
        entryPoint,
        host,
        secretKey,
        accessionNumber,
        studyInstanceUID,
        seriesInstanceUID
      )
      this.urlTarget.href = url
    } catch (error) {
      console.error("Error generating URL:", error)
      alert(error)
    }
  }

  getUrl(entryPoint, host, secret, accessionNumber, studyInstanceUID, seriesInstanceUID) {
    if (!accessionNumber && !studyInstanceUID) {
      throw ('StudyInstanceUID/ACC is mandatory')
    }

    let payload
    let url = host + entryPoint

    if (accessionNumber) {
      payload = String(accessionNumber)
      url += 'a=' + accessionNumber
    } else if (studyInstanceUID) {
      payload = studyInstanceUID
      url += 's1=' + studyInstanceUID
    }

    const date = new Date()
    date.setDate(date.getDate())
    let timestamp = date.getTime()

    timestamp = Math.round(timestamp / 1000) + 86400

    payload += timestamp
    url += '&t=' + timestamp

    const hash = CryptoJS.HmacSHA1(payload, secret)
    const hmac = hash.toString(CryptoJS.enc.Hex)
    url += '&h=' + hmac

    if (seriesInstanceUID && seriesInstanceUID.length > 0) {
      url += '&s2=' + seriesInstanceUID.join(',')
    }

    url += "&r=1"

    console.log("Payload:", payload)
    console.log("url generada", url)

    return url
  }
}
